<template>
  <v-toolbar flat dense>
    <v-spacer></v-spacer>
    <v-dialog width="500">
      <template v-slot:activator="{ on }">
        <v-btn icon small class="mr-2" v-on="on">
          <v-icon small>mdi-table-headers-eye</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          Column Visibility
        </v-card-title>
        <v-card-text>
          <v-checkbox hide-details class="mt-1" v-for="column in columns" :key="column.value" v-model="showColumns" :value="column.value" :label="column.text"></v-checkbox>
        </v-card-text>
      </v-card>
    </v-dialog>

     <v-dialog width="500">
      <template v-slot:activator="{ on }">
        <v-btn :disabled="!selected.length" v-on="on" icon small class="mr-2"><v-icon small>mdi-message</v-icon></v-btn>
      </template>
          <SendCustomMessage 
          :to="recipients" 
          :anonymous="false" 
          :from="user.uid"
          :templateMessagingParams="templateMessagingParams"
          v-on:cancel="closeDialog"
          v-on:sent="closeDialog"></SendCustomMessage>
    </v-dialog> 

      <v-dialog width="500" v-model="dialog">
        <template v-slot:activator="{ on }">
          <v-btn :disabled="!selected.length" v-on="on" icon small class="mr-2"><v-icon small>mdi-pencil</v-icon></v-btn>
        </template>
        <MultiEdit v-on:change="updateMulti" :selected="selected" v-on:close="dialog = false"
        :fields="updateMultiFields"></MultiEdit>
      </v-dialog>
 
     <export-excel
      :data="exportRows"
      :fields="exportColumns"
      :name="project.internalName + '.xls'">
      <v-btn icon small class="mr-2"><v-icon small>mdi-download</v-icon></v-btn>
    </export-excel>

    <v-btn @click="deleteAppointment" icon small class="mr-2"><v-icon small>mdi-close-circle</v-icon></v-btn>

    <v-btn @click="addAppointment" color="green" icon small class="mr-2"><v-icon small>mdi-plus-circle</v-icon></v-btn>
  
  </v-toolbar>
</template>
<script>
import firebase from "firebase";
import Vue from "vue";
import Vuex from "vuex"
import MultiEdit from "../tools/MultiEdit";
import SendCustomMessage from "../tools/SendCustomMessage";
export default {
  name: 'AppointmentTableToolbar',
  props: {
    project: {type: Object},
    rows: {type: Array },
    columns: {type: Array},
    showColumns: {type: Array}, 
    selected: {type: Array}, 
  },
  data: () =>{
    return {
      dialog: false
    }
  },
  components: {
    SendCustomMessage,
    MultiEdit
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.auth.user,
      statuses: state => state.settings.statuses
    }),
    exportColumns: function(){
      let columnObject = {}
      this.columns.filter( column => column.type !== 'button' && column.type !== 'switch').forEach( column => columnObject[column.text] = column.value )
      return columnObject;
    },
    exportRows: function(){
      const self = this;
      var rows = []
      self.rows.forEach( a => {
          var r = {};
          Object.values( self.exportColumns ).forEach( key => {
            r[key] = a[key];
          })
          r.created = Vue.moment(a.created.toDate()).format("HH:mm D/MM/YYYY")
          r.dateTime = Vue.moment(a.dateTime.toDate()).format("HH:mm D/MM/YYYY")
          r.participantName = a.participantObject.displayName;
          r.participantPhone = a.participantObject.phone;
          r.participantEmail = a.participantObject.email;
          rows.push( r );
      });
      return rows;
    },
    recipients: function(){
      const self = this;
      return self.selected.map( a => a.participant );
    },
    templateMessagingParams(){
      const self = this;
      var appointments = self.rows.filter( a => self.recipients.indexOf(a.participant) > -1 ).map( a => { 
        return {
          appointment: a.id, 
          recipient: a.participant,
          project: self.project.id
        }
      })
      return {
        project: self.project.id,
        appointments: appointments  
      }
    },
    updateMultiFields: function(){
      let fields = [
        {data: 'status', type: 'select', options: this.statuses },
        {data: 'quota', type: 'select', options: this.project.quotas }
      ]
      if( this.project.additionalFields ){
        this.project.additionalFields.forEach( field => fields.push({ data: field, type: 'text' }))
      }
      return fields;
    },   
  },
  methods:{
    updateMulti: function(field){
      var self = this;
      self.selected.forEach( row => {
        row[field.data] = field.value;
        self.$store.dispatch("updateDoc", { 
          doc: "appointments/"+row.id, 
          action: "update",
          data: row
        } )
      })
    },
    addAppointment: function(){
      var self = this;
      let newAppointment = {
        publishStatus: "live",
        project: self.project.id,
        methodology: self.project.methodology || 'face-to-face',
        dateTime: firebase.firestore.Timestamp.fromDate(new Date()),
        users: {}
      }
      newAppointment.users[self.user.uid] = "admin";
      self.$store.dispatch("addDoc", { collection: "appointments", data: newAppointment} ).then( ref => {
        self.$store.dispatch("bindAnything", {id: ref.id, collection: "appointments", then: "SET_ANYTHING", reference: "appointments"} )
      });
    },
    deleteAppointment(){
      const self = this;
      let selected = this.selected;
      selected.forEach( a => {
          self.$store.dispatch("updateDoc", { 
            doc: "appointments/"+a.id, 
            action: "update",
            data: {publishStatus: 'deleted'}
          } )
      })
    }
  },
  watch: {
    showColumns(){
      this.$emit("changeColumns", this.showColumns )
    }
  }
};
</script>
